"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEnvironment = void 0;
// This will run when the package is imported
var validateEnvironment = function () {
    if (typeof window !== "undefined") {
        // Log a warning if neither environment is found
        if (!window.STUDENT_ENV && !window.EDUCATOR_ENV && !window.CONTENT_PREVIEW_ENV) {
            console.warn("[Environment] Neither STUDENT_ENV, EDUCATOR_ENV or CONTENT_PREVIEW_ENV is defined on window, attempting to load from process.env");
            window.STUDENT_ENV = process.env;
        }
    }
};
exports.validateEnvironment = validateEnvironment;
// Run validation in all environments
(0, exports.validateEnvironment)();
